import * as React from 'react';
import {Badge, Button, Col, Container, Row} from 'reactstrap';
import Rotate3dIcon from 'mdi-react/Rotate3dIcon';
import ComprobantesForm from './comprobantes-form';
import * as moment from 'moment';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import MeepoServiceClient from '../../../middleware/meepo-client';
import {IComprobante, IResumenDiario} from '../../../utils/models';
import MeepoState from '../../../reduxstore/meepo-state';
import {connect, Store} from 'react-redux';
import {error} from '../../../utils/notification-actions';
import ReactTable from 'react-table';
import {localCurrency} from '../../../utils/number-utils';
import Panel from '../../../theme/components/Panel';
import {colorByEstado, contieneSimilar, isoStrToAMPM, obtenerArregloValores} from '../../../utils/utils';
import MagnifyIcon from 'mdi-react/MagnifyIcon';


interface IState {
    data: any[];
    dataFiltrada: any[];
    fecha?: string;
    ruta?: any;
}

interface IProps {
    resumenDiario: IResumenDiario[];
}

const mapStateToProps = (state) => {
    const stateProps = {
        resumenDiario: state.app.getResumenDiarioXRuta(),
    };
    return stateProps;
};


class ComprobantesView extends React.Component<IProps, IState> {

    @lazyInject(TYPES.MEEPO_SERVICE)
    public apiClient: MeepoServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public store: Store<MeepoState>;

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            dataFiltrada: []
        }
    }

    private get header() {
        return [
            {
                accessor: 'comprobante',
                Header: 'Nro. Documento',
                className: 'center'
            },
            {
                accessor: 'clienteId',
                Header: 'Cod. Cliente',
                className: 'center'
            },
            {
                accessor: 'razonSocial',
                Header: 'Razón Social',
                width: 350,
            },
            {
                accessor: 'monto',
                Header: 'Monto',
                className: 'right'
            },
            {
                accessor: 'estado',
                Header: 'Estado',
                className: 'center',
                Cell: cellInfo => (
                    <Badge color={colorByEstado(cellInfo.row.estado)}>{cellInfo.row.estado}</Badge>
                )
            },

            {
                accessor: 'horaEntrega',
                Header: 'Hora Entrega',
                className: 'center'
            }
        ]
    }

    public handleObtener = async (values) => {
        const fecha = moment(values.fecha).format('YYYY-MM-DD');
        const ruta = values.ruta;
        this.setState({fecha: values.fecha, ruta});
        try {
            const response = [] as any;
            const comprobantes = await this.apiClient.obtenerComprobantesPorRuta(ruta.value, fecha);
            const cambios = await this.apiClient.obtenerCambiosPorRuta(ruta.value, fecha);
            this.setState({
                data: this.transformarData(response.concat(comprobantes).concat(cambios)),
                dataFiltrada: this.transformarData(response.concat(comprobantes).concat(cambios)),
            });
        } catch (ex) {
            this.store.dispatch(error('Error', 'Error interno al obtener comprobantes'));
        }
    };

    private handleSearchPress = (e) => {
        const filtro = e.target.value;
        if (e.key === 'Enter' && this.state.data && this.state.data.length > 0) {
            const filteredData = this.state.data.filter((prod) => {
                const arrValores = obtenerArregloValores(prod);
                return contieneSimilar(arrValores, filtro)
            });
            this.setState({dataFiltrada: filteredData})
        }
    };

    private transformarData = (response: IComprobante[]) => {
        const content: any[] = [];
        response.forEach((item) => {
            content.push({
                comprobante: item.tipo_comprobante === 'GR' ? item.tipo_comprobante + item.numero_comprobante : item.numero_comprobante,
                clienteId: item.cliente.cliente_id,
                razonSocial: item.cliente.razon_social,
                monto: item.monto ? `S/ ${localCurrency(item.monto)}` : null,
                estado: item.estado,
                horaEntrega: isoStrToAMPM(item.updated_at),
            })
        });
        return content;
    };

    private refrescar = () => {
        const {fecha, ruta} = this.state;
        this.handleObtener({fecha, ruta});
    };

    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Reporte de comprobantes</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <ComprobantesForm onSubmit={this.handleObtener} resumenDiario={this.props.resumenDiario}/>
                    </Col>
                    <Col md={9}>
                        <Panel xs={12} md={12} divider={true} title='Lista de comprobantes'>
                            <Row>
                                <Col md={9}>
                                    <div className='form form--horizontal'>
                                        <div className='form__form-group'>
                                            <div className='form__form-group-field'
                                                 style={{marginLeft: 0, paddingLeft: 0}}>
                                                <input
                                                    name='rightIcon'
                                                    onKeyPress={this.handleSearchPress}
                                                    type='text'
                                                    placeholder='Ingrese un texto para filtrar comprobantes'
                                                />
                                                <div className='form__form-group-icon'>
                                                    <MagnifyIcon/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3} style={{textAlign: 'right'}}>
                                    <Button outline={true} className='icon icon--only'
                                            onClick={this.refrescar}><Rotate3dIcon/></Button>
                                </Col>
                            </Row>
                            <ReactTable
                                style={{
                                    margin: 'auto'
                                }}
                                className='rt-custom-table -highlight'
                                columns={this.header} data={this.state.dataFiltrada} showPagination={false}
                                resizable={true}
                                pageSize={this.state.dataFiltrada.length}/>
                        </Panel>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect(mapStateToProps)(ComprobantesView);


// WEBPACK FOOTER //
// ./src/components/pages/comprobantes/comprobantes.tsx